// Debug 
const url_debug = "http://192.168.90.204:89/api"    // intranet
//const url_debug = "http://localhost:56580" // pc


//  Internet Consegne
const url_internetConsegne = "http://api.battisti.cloud/mobile"

// Intranet 
const url_intranet = "http://192.168.90.204:89"


// Update apk
const url_update = 'http://192.168.90.204:89/UpdateApk/version.xml'


export default {

  getUrl() {

    // NOTA: sull'apk window.location.host è vuoto

    if (window.location.host == url_intranet.replace("http://", ""))
      return url_intranet + "/api/api"; // Intranet

    else if (window.location.host.includes("localhost") && window.location.protocol != 'https:')
      return url_debug + "/api" // Debug

    else
      return url_intranet + "/api/api"; // Intranet 

  },

  getUrlConsegneInternet() {
    if (window.location.host.includes("localhost") && window.location.protocol != 'https:')
      return url_debug + "/api" // Debug
    else
      return url_internetConsegne + "/api/api"
  },

  getUpdate() {
    return url_update
  },

  getUrl_Update() {

    let url = "";

    if (window.location.host.includes("localhost"))
      url = ""
    else
      url = window.location.protocol + "//" + window.location.host + "/index.html"

    return url
  }
}